export default __webpack_public_path__ + "media/verification/title_locale_es-68ee0e31.png";